// extracted by mini-css-extract-plugin
export default {"errorMessage":"errorMessage-zh6fk","align-left":"align-left-bVMjW","align-center":"align-center-cNFlz","align-right":"align-right-J8a6D"};